/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { AsinsWithLocationToJSON, ProductPoolMutationResultDTOFromJSON, ProductPoolRequestDTOToJSON, ProductPoolResponseDTOFromJSON, ProductPoolWithdrawResultDTOFromJSON, } from '../models/index';
/**
 *
 */
export class ProductPoolControllerApi extends runtime.BaseAPI {
    /**
     */
    async addAsinsRaw(requestParameters, initOverrides) {
        if (requestParameters['type'] == null) {
            throw new runtime.RequiredError('type', 'Required parameter "type" was null or undefined when calling addAsins().');
        }
        if (requestParameters['asinsWithLocation'] == null) {
            throw new runtime.RequiredError('asinsWithLocation', 'Required parameter "asinsWithLocation" was null or undefined when calling addAsins().');
        }
        const queryParameters = {};
        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/product-pools/add-asins`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['asinsWithLocation'].map(AsinsWithLocationToJSON),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProductPoolMutationResultDTOFromJSON));
    }
    /**
     */
    async addAsins(requestParameters, initOverrides) {
        const response = await this.addAsinsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async addAsinsToPoolRaw(requestParameters, initOverrides) {
        if (requestParameters['type'] == null) {
            throw new runtime.RequiredError('type', 'Required parameter "type" was null or undefined when calling addAsinsToPool().');
        }
        if (requestParameters['productPoolRequestDTO'] == null) {
            throw new runtime.RequiredError('productPoolRequestDTO', 'Required parameter "productPoolRequestDTO" was null or undefined when calling addAsinsToPool().');
        }
        const queryParameters = {};
        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/product-pools`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProductPoolRequestDTOToJSON(requestParameters['productPoolRequestDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProductPoolMutationResultDTOFromJSON));
    }
    /**
     */
    async addAsinsToPool(requestParameters, initOverrides) {
        const response = await this.addAsinsToPoolRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getProductPoolRaw(requestParameters, initOverrides) {
        if (requestParameters['type'] == null) {
            throw new runtime.RequiredError('type', 'Required parameter "type" was null or undefined when calling getProductPool().');
        }
        if (requestParameters['location'] == null) {
            throw new runtime.RequiredError('location', 'Required parameter "location" was null or undefined when calling getProductPool().');
        }
        const queryParameters = {};
        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }
        if (requestParameters['location'] != null) {
            queryParameters['location'] = requestParameters['location'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/product-pools`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => ProductPoolResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async getProductPool(requestParameters, initOverrides) {
        const response = await this.getProductPoolRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async requestAsinsRaw(requestParameters, initOverrides) {
        if (requestParameters['count'] == null) {
            throw new runtime.RequiredError('count', 'Required parameter "count" was null or undefined when calling requestAsins().');
        }
        if (requestParameters['type'] == null) {
            throw new runtime.RequiredError('type', 'Required parameter "type" was null or undefined when calling requestAsins().');
        }
        if (requestParameters['location'] == null) {
            throw new runtime.RequiredError('location', 'Required parameter "location" was null or undefined when calling requestAsins().');
        }
        const queryParameters = {};
        if (requestParameters['count'] != null) {
            queryParameters['count'] = requestParameters['count'];
        }
        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }
        if (requestParameters['location'] != null) {
            queryParameters['location'] = requestParameters['location'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/product-pools/request-asins`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => ProductPoolWithdrawResultDTOFromJSON(jsonValue));
    }
    /**
     */
    async requestAsins(requestParameters, initOverrides) {
        const response = await this.requestAsinsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async setAutoCreateSearchRaw(requestParameters, initOverrides) {
        if (requestParameters['type'] == null) {
            throw new runtime.RequiredError('type', 'Required parameter "type" was null or undefined when calling setAutoCreateSearch().');
        }
        if (requestParameters['location'] == null) {
            throw new runtime.RequiredError('location', 'Required parameter "location" was null or undefined when calling setAutoCreateSearch().');
        }
        if (requestParameters['enabled'] == null) {
            throw new runtime.RequiredError('enabled', 'Required parameter "enabled" was null or undefined when calling setAutoCreateSearch().');
        }
        const queryParameters = {};
        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }
        if (requestParameters['location'] != null) {
            queryParameters['location'] = requestParameters['location'];
        }
        if (requestParameters['enabled'] != null) {
            queryParameters['enabled'] = requestParameters['enabled'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/product-pools/auto-search`;
        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => ProductPoolResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async setAutoCreateSearch(requestParameters, initOverrides) {
        const response = await this.setAutoCreateSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
/**
 * @export
 */
export const AddAsinsTypeEnum = {
    Keyword: 'KEYWORD',
    Store: 'STORE',
    Extension: 'EXTENSION'
};
/**
 * @export
 */
export const AddAsinsToPoolTypeEnum = {
    Keyword: 'KEYWORD',
    Store: 'STORE',
    Extension: 'EXTENSION'
};
/**
 * @export
 */
export const SetAutoCreateSearchTypeEnum = {
    Keyword: 'KEYWORD',
    Store: 'STORE',
    Extension: 'EXTENSION'
};
/**
 * @export
 */
export const SetAutoCreateSearchLocationEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
